import { ImgAtenInfo, ImgErrorInfo2, ImgWspInfo } from '../../svg/automovilcr';

const StepNoAccept = () => {

    return (
        <div className="layout">
            <div className="reponsive-width-12">
                <div className=''>
                    <p className=" txt-center lbl-color n-accept-title" >Gracias por confiar en Seguros LAFISE, su proceso ha finalizado si requiere mayor información puede contactarnos</p>

                </div>
            </div>
            <div className='n-accept n-accept-d '>
                <div className='w20 img'>
                    <ImgAtenInfo wth={70} />
                </div>

                <div className='w80'>
                    <p className='lbl-color-secondary lbl-t'><strong>Atención Telefónica</strong></p>
                    <p className='lbl-color lbl-t'>En nuestra central telefónica <strong>2246-2700</strong> estamos para  servirle de 8:00 a.m. a 5:00 p.m. de lunes a viernes.</p>
                </div>
            </div>
            <div className='n-accept n-accept-d '>
                <div className='w20 img'>
                    <ImgWspInfo wth={70} />
                </div>

                <div className='w80'>
                    <p className='lbl-color-secondary'><strong>WhatsApp Business</strong></p>
                    <p className='lbl-color'>Será un gusto atenderle por medio de nuestro WhatsApp Bussiness al <strong>6094-7218</strong></p>
                </div>
            </div>
            <div className='n-accept-img'>
                <ImgErrorInfo2 wth={70} />
            </div>
            <div className='n-accept'>
                <button className="control-button-btn" type="button" onClick={() => {  window.location.href = '/ProductosDigitales/micrositio/audebitoautomaticocr'; }} >
                    Finalizar
                </button>
            </div>
        </div>

    );
}

export default StepNoAccept;